import React from 'react';
import RawImg from './RawImg';

interface InfoSectionProps {
  specNum: number;
  imageSrc: string;
  altText: string;
  imageClass: string;
  description: string;
}



const InfoSection: React.FC<InfoSectionProps> = ({
  specNum,
  description,
  imageSrc,
  altText,
  imageClass,
}) => {
  const isEven = specNum % 2 === 0;
  const translateClass = isEven ? 'md:translate-x-[-30px]' : 'md:translate-x-[30px]';
  const flexJustifyClass = isEven ? '' : 'justify-end';

  const textCont = (
    <div
      className={`flex-[0_0_72%] max-sm:w-full max-w-[540px] max-sm:flex-[0_0_100%] ${translateClass} relative z-[-1] max-sm:order-2`}
    >
      <div className="p-[51px] pl-[52px] leading-[22px] text-xl font-bold text-black bg-yellow-400 rounded-3xl border-yellow-400 border-solid border-[3px] max-md:px-12 max-md:py-10 max-md:text-lg max-sm:p-8 max-sm:text-base">
        {description}
      </div>
    </div>
  );

  const imgCont = (
    <div className="overflow-hidden rounded-3xl flex-[0_0_28%] max-sm:w-full max-sm:flex-[0_0_100%] max-sm:order-1">
      <RawImg
        image={imageSrc}
        altText={altText}
        className={`object-cover w-full h-auto rounded-3xl border-4 border-yellow-400 border-solid ${imageClass}`}
      />
    </div>
  );

  return (
    <div
      className={`flex gap-5 items-center mb-0 max-sm:flex-col max-sm:gap-5 max-w-[1070px] mx-auto ${flexJustifyClass} mb-5`}
    >
      {isEven ? (
        <>
          {imgCont}
          {textCont}
        </>
      ) : (
        <>
        {textCont}
        {imgCont}
          
        </>
      )}
    </div>
  );
};

export default InfoSection;